<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center"><span>What Men Don’t Tell Women</span></h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?fc6d2ef4